/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 382);
/******/ })
/************************************************************************/
/******/ ({

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(383);
module.exports = __webpack_require__(384);


/***/ }),

/***/ 383:
/***/ (function(module, exports) {

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    DOMUtils = _window$Liftoff.DOMUtils,
    Utils = _window$Liftoff.Utils;

var Tiler = function () {
  function Tiler(_ref) {
    var tileElement = _ref.tileElement,
        _ref$minColumnCount = _ref.minColumnCount,
        minColumnCount = _ref$minColumnCount === undefined ? 1 : _ref$minColumnCount,
        _ref$maxColumnCount = _ref.maxColumnCount,
        maxColumnCount = _ref$maxColumnCount === undefined ? 20 : _ref$maxColumnCount,
        targetWidth = _ref.targetWidth,
        _ref$minRowCount = _ref.minRowCount,
        minRowCount = _ref$minRowCount === undefined ? 1 : _ref$minRowCount,
        _ref$maxRowCount = _ref.maxRowCount,
        maxRowCount = _ref$maxRowCount === undefined ? 20 : _ref$maxRowCount,
        targetHeight = _ref.targetHeight;

    _classCallCheck(this, Tiler);

    var _tileElement$getBound = tileElement.getBoundingClientRect(),
        width = _tileElement$getBound.width,
        height = _tileElement$getBound.height;

    var rowCount = Math.ceil(Utils.clamp(targetHeight / height, minRowCount, maxRowCount));
    var columnCount = Math.ceil(Utils.clamp(targetWidth / width, minColumnCount, maxColumnCount));

    this.element = DOMUtils.createElement({
      classList: ["tiler"],
      children: Utils.range(0, rowCount).map(function () {
        return {
          classList: ["tiler-row"],
          children: Utils.range(0, columnCount).map(function () {
            return {
              style: { width: width + "px", height: height + "px" },
              classList: ["tiler-cell"],
              children: [tileElement.cloneNode(true)]
            };
          })
        };
      })
    });
  }

  _createClass(Tiler, [{
    key: "getElement",
    value: function getElement() {
      return this.element;
    }
  }]);

  return Tiler;
}();

Component.register("panning", function (_Component) {
  _inherits(Panning, _Component);

  function Panning(config) {
    _classCallCheck(this, Panning);

    var _this = _possibleConstructorReturn(this, (Panning.__proto__ || Object.getPrototypeOf(Panning)).call(this, config));

    Utils.assignWithDefaults(_this, {
      speed: 10,
      direction: "left",
      images: []
    }, _this.config);

    _this.images = _this.images.filter(function (_ref2) {
      var image = _ref2.image;
      return !!image;
    }).map(function (_ref3) {
      var image = _ref3.image;
      return image;
    });
    _this.animating = _this.ready = false;
    return _this;
  }

  _createClass(Panning, [{
    key: "load",
    value: function load() {
      this.imagesPromises = Promise.all(this.images.map(function (image) {
        return Utils.loadImage(image);
      }));

      return this.imagesPromises;
    }
  }, {
    key: "layout",
    value: function layout(parentNode) {
      var _this2 = this;

      _get(Panning.prototype.__proto__ || Object.getPrototypeOf(Panning.prototype), "layout", this).call(this, parentNode);

      this.imageSliderEl = DOMUtils.createElement({
        classList: ["image-slider"]
      });

      this.el = DOMUtils.createElement({
        classList: ["panning"],
        children: [this.imageSliderEl]
      });

      this.parentNode.appendChild(this.el);

      this.addEventListeners();

      var _el$getBoundingClient = this.el.getBoundingClientRect(),
          visibleWidth = _el$getBoundingClient.width,
          visibleHeight = _el$getBoundingClient.height;

      this.imagesPromises.then(function (imageEls) {
        // If there are no images, `this.ready` will never be set to true.
        // In the event that the images can be set via coordination, this
        // logic should be pulled out into its own method.
        if (imageEls.length === 0) return;

        var imageSetTemplateEl = DOMUtils.createElement({
          classList: ["image-set"],
          children: imageEls
        });

        _this2.imageSliderEl.appendChild(imageSetTemplateEl);

        var isVertical = ["up", "down"].includes(_this2.direction);

        var scrollSize = isVertical ? imageSetTemplateEl.getBoundingClientRect().height : imageSetTemplateEl.getBoundingClientRect().width;

        var visibleSize = isVertical ? visibleHeight : visibleWidth;

        var keyframeTransforms = isVertical ? ["translate3d(0, " + -scrollSize + "px, 0)", null] : ["translate3d(" + -scrollSize + "px, 0, 0)", null];
        if (["up", "left"].includes(_this2.direction)) {
          _this2.finalTransform = keyframeTransforms[0];
          _this2.initialTransform = keyframeTransforms[1];
        } else {
          _this2.initialTransform = keyframeTransforms[0];
          _this2.finalTransform = keyframeTransforms[1];
        }

        // The speed is the percent of the container width covered in 1 second.
        var duration = scrollSize / visibleSize / (_this2.speed / 100);
        _this2.transition = "transform linear " + duration + "s";

        _this2.imageSetTiler = new Tiler({
          tileElement: imageSetTemplateEl,
          minColumnCount: isVertical ? 1 : 2,
          targetWidth: visibleWidth * (isVertical ? 1 : 2),
          minRowCount: isVertical ? 2 : 1,
          targetHeight: visibleHeight * (isVertical ? 2 : 1)
        });

        imageSetTemplateEl.remove();

        _this2.imageSliderEl.appendChild(_this2.imageSetTiler.getElement());

        _this2.ready = true;
        _this2.pan();
      });
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;

      this.imageSliderEl.addEventListener("transitionend", function () {
        _this3.pan();
      });
    }
  }, {
    key: "resize",
    value: function resize() {}
  }, {
    key: "start",
    value: function start() {
      this.animating = true;
      this.pan();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.animating = false;
      this.resetPanner();
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      this.start();
    }
  }, {
    key: "resetPanner",
    value: function resetPanner() {
      Object.assign(this.imageSliderEl.style, {
        transform: this.initialTransform,
        transition: null
      });

      DOMUtils.forceReflow(this.el);
    }
  }, {
    key: "pan",
    value: function pan() {
      if (!(this.ready && this.animating)) return;

      this.resetPanner();

      Object.assign(this.imageSliderEl.style, {
        transform: this.finalTransform,
        transition: this.transition
      });
    }
  }]);

  return Panning;
}(Component));

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// panning-7c9fad3db65b52085cad.js